import React from 'react'
import { IconCheck } from '../../../shared/icon/icon'

export const SuccessView = () => (
  <div className="ld-success">
    <div className="ld-success__badge"><IconCheck /></div>
    <div className="ld-success__label">Signed in</div>
  </div>
)
